export default __webpack_public_path__ + "static/media/ethereum.1f8c0314.svg";